function webpackEmptyContext(req) {
	throw new Error("Cannot find module '" + req + "'.");
}
webpackEmptyContext.keys = function() { return []; };
webpackEmptyContext.resolve = webpackEmptyContext;
module.exports = webpackEmptyContext;
webpackEmptyContext.id = "EgBY";


//////////////////
// WEBPACK FOOTER
// ./redevelopment/main/workspace ^\.\/.*$
// module id = EgBY
// module chunks = 0